import React, { useEffect, useState } from "react";
import { Collapse, ListGroup } from "react-bootstrap";
import { usersOnboardingService } from "../../APIServices/usersOnboarding";
import { ImAddressBook } from "react-icons/im";

function EIWRSSidebar({ studyId, handleAddNewTab, checkActiveTab, collapseSidebar }) {
  const [studyLabel, setStudyLabel] = useState("");
  const [openMenu, setOpenMenu] = useState({});
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  useEffect(() => {
    const fetchStudyLabel = async () => {
      const { data } = await usersOnboardingService.findStudyLabel(studyId);
      setStudyLabel(data);
    };
    fetchStudyLabel();
  }, [studyId]);

  const toggleFolder = (id) => {
    setOpenMenu((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const menuItems = [
    ...((StudyMode === "DBP Mode"
      || eiwrsPermission?.liveManageSubjectScreening
      || eiwrsPermission?.liveViewSubjectScreening
      || eiwrsPermission?.qcManageSubjectScreening
      || eiwrsPermission?.qcViewSubjectScreening)
      ? [{
        id: "subjectScreening",
        label: "Screening",
        icon: "fa-solid fa-user-check",
      }] : []),
    ...(StudyMode === "DBP Mode"
      ? [
        {
          id: "randomizationSchema",
          label: "Randomization Settings",
          folder: true,
          children: [
            {
              id: "randomizationSchemas",
              label: "Manage Schema",
              icon: "fa-solid fa-dice",
              fullLabel: "Randomization Schemas"
            },
            {
              id: "assignrandomizationSchemaSite",
              label: "Assign Schema Site",
              fullLabel: "Assign Randomization Schema Site",
              icon: "fa-solid fa-link"
            },
            {
              id: "assignedBasedRandomization",
              label: "Assign Based Randomization",
              icon: "fa-solid fa-dice",
              fullLabel: "Assign Based Randomization"
            },
          ]
        }
      ]
      : (eiwrsPermission?.liveRandomizationSchema
        || eiwrsPermission?.qcRandomizationSchema) ? [{
          id: "randomizationSchemas",
          label: "Randomization Schemas",
          icon: "fa-solid fa-dice",
          fullLabel: "Randomization Schemas"
        }] : []),
    {
      id: "randomization",
      label: "Randomization",
      icon: "fa-solid fa-dice-d6"
    },
    ...((StudyMode === "DBP Mode"
      || eiwrsPermission?.liveEnvelopeView
      || eiwrsPermission?.qcEnvelopeView)
      ? [{
        id: "envelopeView",
        label: "Envelope View",
        icon: "fa-solid fa-envelope"
      }] : []),
    ...(StudyMode === "DBP Mode" ? [{
      id: "depotManagement",
      label: "Depot Management",
      folder: true,
      children: [
        {
          id: "manageDepotMetadata",
          label: "Manage Metadata",
          fullLabel: "Manage Depot Metadata",
          icon: "fa-solid fa-list-check"
        },
        {
          id: "manageDepot",
          label: "Manage Depot",
          icon: "fa-regular fa-hospital"
        },
      ]
    }] : (eiwrsPermission?.liveDepotInventory
      || eiwrsPermission?.qcDepotInventory) ? [{
        id: "manageDepot",
        label: "Depot Management",
        icon: "fa-regular fa-hospital"
      }] : []
    ),
    ...(StudyMode === "DBP Mode"
      || eiwrsPermission?.liveKitManagement
      || eiwrsPermission?.qcKitManagement
      || eiwrsPermission?.liveKitInventory
      || eiwrsPermission?.qcKitInventory) ? [{
        id: "kitManagement",
        label: "Kit Management",
        folder: true,
        children: [
          ...(StudyMode === "DBP Mode" ? [
            {
              id: "kitSchemaManagement",
              label: "Kit Schema",
              icon: "fa-solid fa-list-check"
            },
            {
              id: "kitMetadata",
              label: "Kit Metadata",
              icon: "fa-solid fa-list-check"
            },
            {
              id: "kitTypeMetadata",
              label: "Kit Type",
              icon: "fa-solid fa-list-check"
            },
            {
              id: "kitQuanrantineReasonMeta",
              label: "Quanrantine Reason",
              icon: "fa-solid fa-list-check"
            },
            {
              id: "kitBatchNumberMetadata",
              label: "Kit Batch No.",
              icon: "fa-solid fa-list-check"
            }
          ] : []),
          ...(StudyMode === "DBP Mode") ? [{
            id: "kitOverview",
            label: "Kit Overview",
            icon: "fa-solid fa-magnifying-glass-chart"
          }] : [],
          ...(StudyMode === "DBP Mode"
            || eiwrsPermission?.liveKitManagement
            || eiwrsPermission?.qcKitManagement) ? [{
              id: "kitPreparation",
              label: "Kit Preparation",
              icon: "fa-solid fa-kit-medical"
            }] : [],
          ...(StudyMode === "DBP Mode"
            || eiwrsPermission?.liveKitInventory
            || eiwrsPermission?.qcKitInventory) ? [{
              id: "kitInventory",
              label: "Kit Inventory",
              icon: "fa-solid fa-briefcase-medical"
            }] : [],
        ]
      }] : [],
    ...(StudyMode === "DBP Mode" ? [{
      id: "siteManagement",
      label: "Site Management",
      folder: true,
      children: [
        {
          id: "assignDepotSite",
          label: "Assign Depot Site",
          fullLabel: "Assign Depot Site",
          icon: "fa-solid fa-link"
        },
        {
          id: "siteInventory",
          label: "Site Inventory",
          icon: "fa-solid fa-building"
        }
      ]
    }] : (eiwrsPermission?.liveSiteManagement
      || eiwrsPermission?.qcSiteManagement
      || eiwrsPermission?.liveSiteInventory
      || eiwrsPermission?.qcSiteInventory) ? [{
        id: "siteInventory",
        label: "Site Management",
        icon: "fa-solid fa-building"
      }] : []),
    ...(StudyMode === "DBP Mode" ? [{
      id: "shipmentsManagement",
      label: "Shipment Management",
      folder: true,
      children: [
        {
          id: "corierManagement",
          label: "Corier Management",
          folder: true,
          children: [
            {
              id: "courierMetaData",
              label: "Manage Metadata",
              fullLabel: "Manage Courier Metadata",
              icon: "fa-solid fa-list-check"
            },
            {
              id: "courierData",
              label: "Manage Corier",
              fullLabel: "Manage Courier",
              icon: "fa-solid fa-truck-fast"
            }
          ]
        },
        {
          id: "temperatureData",
          label: "Temperature Metadata",
          fullLabel: "Manage Temperature Metadata",
          icon: "fa-solid fa-temperature-full"
        },
        {
          id: "manageShipment",
          label: "Manage Shipment",
          icon: "fa-solid fa-box-archive"
        }
      ]
    }] : (eiwrsPermission?.liveKitShipmentManagement
      || eiwrsPermission?.qcKitShipmentManagement) ? [{
        id: "manageShipment",
        label: "Shipment Management",
        icon: "fa-solid fa-box-archive"
      }] : []),
    ...(StudyMode === "DBP Mode"
      || eiwrsPermission?.liveManageUnblindingRequest
      || eiwrsPermission?.liveViewUnblindingRequest
      || eiwrsPermission?.liveManageEmergencyUnblinding
      || eiwrsPermission?.liveViewEmergencyUnblinding
      || eiwrsPermission?.qcManageUnblindingRequest
      || eiwrsPermission?.qcViewUnblindingRequest
      || eiwrsPermission?.qcManageEmergencyUnblinding
      || eiwrsPermission?.qcViewEmergencyUnblinding) ? [{
        id: "unblindManagement",
        label: "Unblind Management",
        folder: true,
        children: [
          ...(StudyMode === "DBP Mode" ? [{
            id: "unblindingReasonMetadata",
            label: "Reason Metadata",
            fullLabel: "Reason Metadata",
            icon: "fa-solid fa-list-check"
          },
          {
            id: "unblindingRequestTypeMetadata",
            label: "Request Type Meta",
            icon: "fa-solid fa-list-check"
          }] : []),
          ... (StudyMode === "DBP Mode"
            || eiwrsPermission?.liveManageUnblindingRequest
            || eiwrsPermission?.liveViewUnblindingRequest
            || eiwrsPermission?.qcManageUnblindingRequest
            || eiwrsPermission?.qcViewUnblindingRequest) ? [{
              id: "unblindingRequests",
              label: "Unblinding Requests",
              icon: "fa-solid fa-eye-slash"
            }] : [],
          ... (StudyMode === "DBP Mode"
            || eiwrsPermission?.liveManageEmergencyUnblinding
            || eiwrsPermission?.liveViewEmergencyUnblinding
            || eiwrsPermission?.qcManageEmergencyUnblinding
            || eiwrsPermission?.qcViewEmergencyUnblinding) ? [{
              id: "emergencyUnblinding",
              label: "Emergency Unblinding",
              icon: "fa-solid fa-shield-halved"
            }] : [],
        ]
      }] : [],
    ... (StudyMode === "DBP Mode"
      || eiwrsPermission?.liveGenerateReport
      || eiwrsPermission?.liveViewReport
      || eiwrsPermission?.qcGenerateReport
      || eiwrsPermission?.qcViewReport) ? [{
        id: "eiwrsReports",
        label: "Reports",
        icon: "fa-solid fa-file-pen"
      }] : [],
    ... (StudyMode === "DBP Mode"
      || eiwrsPermission?.liveAuditTrail
      || eiwrsPermission?.qcAuditTrail) ? [{
        id: "eiwrsAuditTrail",
        label: "Audit Trail",
        icon: "fa-solid fa-clock-rotate-left"
      }] : [],
  ];

  const MenuItem = ({ item, level = 0 }) => (
    <ListGroup.Item
      action
      className={`border-0 border-bottom ${checkActiveTab(item.id) && "selectedMenu"}`}
      style={{
        padding: `7px 10px 7px ${collapseSidebar ? "15px" : `${25 + level * 20}px`
          }`,
        fontSize: "13px",
        lineHeight: "18px",
      }}
      onClick={() => handleAddNewTab(item.fullLabel || item.label, item.icon, item.id)}
      title={item.fullLabel || item.label}
    >
      <div className="hstack justify-content-between w-100">
        <span className="d-flex align-items-center">
          <i
            className={`${item.icon} me-2`}
            style={{
              fontSize: "12px",
              width: 16,
              textAlign: "center",
            }}
          ></i>

          {!collapseSidebar && item.label}
        </span>
      </div>
    </ListGroup.Item>
  );

  const FolderMenuItem = ({ item, level = 0 }) => (
    <React.Fragment key={item.id}>
      <ListGroup.Item
        action
        className={`border-0 border-bottom ${openMenu[item.id] ? "bg-light" : ""}`}
        style={{
          padding: `7px 10px 7px ${collapseSidebar ? "15px" : `${25 + level * 20}px`}`,
        }}
        onClick={() => toggleFolder(item.id)}
      >
        <div className="hstack justify-content-between w-100">
          <span>
            <i
              className={`fa-solid fa-${openMenu[item.id] ? "folder-open" : "folder"
                } me-2`}
            ></i>

            {!collapseSidebar && item.label}
          </span>

          {!collapseSidebar && (
            <i
              className={`fa-solid fa-angle-${openMenu[item.id] ? "down" : "right"
                }`}
            ></i>
          )}
        </div>
      </ListGroup.Item>

      <Collapse
        in={openMenu[item.id]}
      >
        <div>
          {item.children?.map((child) =>
            child.folder ? (
              <FolderMenuItem
                key={child.id}
                item={child}
                level={level + 1}
              />
            ) : (
              <div key={child.id}>
                <ListGroup.Item
                  action
                  className={`border-0 border-bottom ${checkActiveTab(child.id) && "selectedMenu"
                    }`}
                  style={{
                    fontSize: 13,
                    padding: `7px 10px 7px ${collapseSidebar ? "15px" : `${45 + level * 20}px`
                      }`,
                  }}
                  onClick={() =>
                    handleAddNewTab(
                      child.fullLabel || child.label,
                      child.icon,
                      child.id
                    )
                  }
                  title={child.fullLabel || child.label}
                >
                  <i className={`${child.icon} me-2`} style={{ fontSize: 12 }}></i>

                  {!collapseSidebar && child.label}
                </ListGroup.Item>
              </div>
            )
          )}
        </div>
      </Collapse>
    </React.Fragment>
  );

  return (
    <div className="sidebar" id="myGroup">
      <div className="menus">
        <ListGroup className="w-100">
          {/* Header */}
          <ListGroup.Item
            className="border-0 border-bottom text-white rounded-0"
            style={{ padding: "6px 15px", background: "var(--blue)" }}
          >
            <div className="hstack justify-content-between w-100">
              <span className="fw-bold hstack" style={{ height: 18 }}>
                <ImAddressBook className="me-1" />
                {!collapseSidebar && studyLabel}
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
            {menuItems.map(item => {
              if (item.folder) {
                return (
                  <FolderMenuItem key={item.id} item={item} level={0} />
                );
              } else {
                return (
                  <MenuItem key={item.id} item={item} level={0} />
                );
              }
            })}
          </ListGroup>
        </ListGroup>
      </div>
    </div>
  );
}

export default EIWRSSidebar;